import styled from 'styled-components'

import * as colors from '../../constants/colors'

const DiscreetText = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.light ? 300 : 400)};
  color: ${colors.GREY_SHADE_2};
`

export default DiscreetText
